import * as monaco from 'monaco-editor';

const getWorkerUrlByLabel = (label: string) => {
  if (label === 'json') {
    return '/json.worker.js';
  }
  if (label === 'css' || label === 'scss' || label === 'less') {
    return '/css.worker.js';
  }
  if (label === 'html' || label === 'handlebars' || label === 'razor') {
    return '/html.worker.js';
  }
  if (label === 'typescript' || label === 'javascript') {
    return '/ts.worker.js';
  }
  return '/editor.worker.js';
};

const monacoEditor = ({
  ref,
  options,
  override,
}: {
  ref: HTMLDivElement;
  options: monaco.editor.IStandaloneEditorConstructionOptions;
  override?: monaco.editor.IEditorOverrideServices;
}) => {
  self.MonacoEnvironment = {
    getWorkerUrl: function (_moduleId, label) {
      const url = new URL(getWorkerUrlByLabel(label), location.origin);
      console.log('[Monaco] Loading worker for:', label);
      const blob = new Blob([`import "${url.toString()}"`], {
        type: 'application/javascript',
      });
      return URL.createObjectURL(blob);
    },
  };
  return {
    instance: monaco.editor.create(ref, options, override),
    monaco,
  };
};

export const getMonacoLanguageFromMime = (mime: string) => {
  return monaco.languages.getLanguages().find((language) => {
    return language.mimetypes?.includes(mime);
  })?.id;
};

export default monacoEditor;
